module.exports = __webpack_public_path__ + "img/chara_line_3_white.9e57b066.png";